//----- Component --------------------------------------------------------/

// Developer :  Nicolas Pascucci

// Creation Date : 11/02/2025

// Version : 1

// Description : Detalle de los talles en el inventarioks

//

//------Changes --------------------------------------------------------------------- -------------//

// Change Date :

// Change by :

// Change description:

//

// Change Date :

// Change by :

// Change description:

//
//========================================================================/
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { getData } from "../../../services/library";

function DetalleArticulo({ row }) {
  const [stockTalles, setStockTalles] = useState([]);

  useEffect(() => {
    if (row.tiene_talles === 1) {
      getData(
        `/stock_prendas/detalle/${row.id_almacen}/${row.id_articulo}`,
        setStockTalles
      );
    }
  }, []);

  return (
    <Box
  sx={{
    width: "calc(100% + 600px)", // Intenta expandir el ancho total
    // minWidth: "100vw", // Ocupar todo el ancho disponible
    bgcolor: "#EBF5FB",
    border: 1,
    borderColor: "#A9CCE3",
    borderRadius: 2,
    p: 2,
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: 2,
  }}
>

      {stockTalles.length > 0 ? (
        stockTalles.map((item) => (
          <Box
            key={item.id}
            sx={{
              bgcolor: "#D6EAF8",
              borderRadius: 2,
              textAlign: "center",
              p: 2,
              minWidth: "100px",
              flex: "1 1 120px", // Se ajusta automáticamente, mínimo 150px
              boxShadow: 1,
            }}
          >
            <Typography variant="body1" fontWeight="bold">
              {item.nombre_talle}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Cantidad: {item.cantidad}
            </Typography>
          </Box>
        ))
      ) : (
        <Typography
          variant="body2"
          color="textSecondary"
          sx={{ textAlign: "center", width: "100%", py: 2 }}
        >
          No hay stock disponible
        </Typography>
      )}
    </Box>
  );
}

export default DetalleArticulo;
